module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipts"
  }, [_c('table', {
    staticClass: "ui very basic unstackable table"
  }, [_c('tbody', _vm._l((_vm.receipts), function(receipt) {
    return (_vm.price(receipt) !== 0) ? _c('tr', [_c('td', {
      staticClass: "four wide right aligned name"
    }, [_vm._v(_vm._s(receipt.name))]), _c('td', {
      staticClass: "three wide right aligned quantity"
    }, [_vm._v(_vm._s(_vm.quantity_unit(receipt)) + " " + _vm._s(_vm.to_brackets(receipt.unit_note)))]), _c('td', {
      staticClass: "three wide right aligned quantity"
    }, [_vm._v(_vm._s(_vm.$formatters.money(receipt.unit_price)))]), _c('td', {
      staticClass: "four wide right aligned money"
    }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.price(receipt))))]), _c('td', {
      staticClass: "two wide"
    })]) : _vm._e()
  })), _c('tfoot', [_c('th', {
    staticClass: "four wide right aligned summary"
  }, [_vm._v("合计")]), _c('th', {
    staticClass: "three wide"
  }), _c('th', {
    staticClass: "three wide"
  }), _c('th', {
    staticClass: "four wide right aligned money"
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.summary.price)))]), _c('th', {
    staticClass: "two wide"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27f39f1f","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/Receipts.vue
// module id = 320
// module chunks = 0